import type { Form } from 'factorial-form'
import {
  type ProfileEmployeeResourceFieldDataFragment,
  type ValueDataFragment,
} from 'generated/resources/graphql'
import sortBy from 'lodash/sortBy'

import { createForm } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/createForm'

interface CustomFieldsForm {
  forms: Form[]
  isVisible: boolean
  hasCustomFieldTypes: boolean
}

export const getForm = (
  customResourceFieldsData: ProfileEmployeeResourceFieldDataFragment[],
  customValuesData: ValueDataFragment[]
): CustomFieldsForm => {
  const visibleCustomResourceFields = customResourceFieldsData.filter(({ field }) => field?.visible)

  const forms = sortBy(visibleCustomResourceFields, ({ field }) => field?.position).map(
    (customResourceField) => {
      const customValue = customValuesData.find(
        (value) => value.fieldId === customResourceField.field?.id
      )
      return createForm(customResourceField, customValue)
    }
  )

  return {
    forms: forms,
    isVisible: visibleCustomResourceFields.length > 0 && forms.length > 0,
    hasCustomFieldTypes: visibleCustomResourceFields.length > 0,
  }
}
